<template>
<fieldset :disabled="loading">
    <div>
        <div>            
            <div v-if="mustChooseAccount">
                <form @submit.prevent="chooseAccount = false">
                    <div class="form-group">
                        <label>{{translate('login.accountCode')}}</label>
                        <input v-model="accountCode" type="text" class="form-control" aria-describedby="accountHelp" required />
                    </div>
                    <div class="text-right">
                        <button type="submit" class="btn btn-primary">{{translate('login.continue')}}</button>
                    </div>
                </form>
            </div>
            <div v-else>
                <div v-show="imzalayiciMode == 'sign'">
                    <div class="text-center">
                        <span v-html="translate('login.eSignatureApprovalText:' + accountCode)"></span>
                    </div>
                    <div class="text-center" style="padding-bottom:26px;">
                        <button v-if="!isAccountCodeHidden" type="button" @click="signingItems = null; errorMessage = null; chooseAccount = true;" class="btn btn-link">{{translate('login.changeAccount')}}</button>
                    </div>
                </div>

                <form @submit.prevent="sign">
                    <imzalayici ref="imzalayici" :showFileList="false" :autoSubmit="false" :processingMessage="processingMessage" :items="signingItems" @onerror="imzalayiciOnError" @modechange="imzalayiciModeChange" @onloading="imzalayiciOnLoading" @completed="signingCompleted">
                    </imzalayici>
                    <div class="clear-fix" v-show="imzalayiciMode == 'sign'">
                        <button type="submit" class="btn btn-success btn-block" v-show="!imzalayiciLoading">{{translate('login.login')}}</button>
                    </div>
                </form>
            </div>
            <div class="text-danger">
                {{errorMessage}}
            </div>
        </div>
    </div>
</fieldset>
</template>

<script>
// @ is an alias to /src
import Imzalayici from '@/components/Imzalayici.vue'
import axios from 'axios'

export default {
    name: 'LoginWithESignature',
    components: {
        Imzalayici
    },
    data() {
        return {
            chooseAccount: true,
            accountCode: window.settings.defaultAccountCode,
            imzalayiciLoading: false,   // İmzalayıcı 'loading' pozisyonunda mı
            items: [],
            processingMessage: null,
            loading: false,
            signingItems: [{
                    SigningFunction: 'getsignaturevalue',
                    DocumentId : 'login-agreement',
                    FileName : 'Kullanıcı oturum açma sözleşmesi',
                    SignatureFormat : 'CAdES',
                    Size : 0,
                    State : '',
                    GetUrl: 'token/ESignatureLoginAgreement?accountCode=' + this.accountCode,
                    PostParams: {  }
                }],
            errorMessage: null,
            imzalayiciMode: 'sign'  // İmzalayıcı arayüz modu (sign/selectcert) İmzalama / Sertifika seçim paneli
        }
    },
    computed:{
        isAccountCodeHidden(){
            if(this.isOnPrem && window.settings.defaultAccountCode)
                return window.settings.authentication?.hideAccountCode;
            else
                return false;
        },
        mustChooseAccount(){
            return !this.isAccountCodeHidden && this.chooseAccount;
        }
    },
    methods:{
        
        signingCompleted(){
            this.loading = true;
            this.processingMessage = this.translate('processingMessages.signatureValidating');
            //console.log('imzalı veri', this.signingItems[0].SignedContent);

            axios.post('token/ESignatureLoginAgreement', { accountCode: this.accountCode, Base64Signature: this.signingItems[0].SignedContent, TransactionId: this.signingItems[0].TransactionId })
            .then(x => {
                console.log('login result:', x);
                if(x.data.Success) {
                    window.localStorage.setItem('user', JSON.stringify(x.data.Data));
                    axios.defaults.headers.common['token'] = x.data.Data.Key;
                    this.$root.$data.login = x.data.Data;

                    if(this.$route.query.redirect)
                        this.$router.push(this.$route.query.redirect);
                    else
                        this.$router.push('/' + x.data.Data.Account.Code);
                } else {
                    this.errorMessage = x.data.ErrorMessages;
                    this.loading = false;
                    this.imzalayiciLoading = false;
                }
            })
            .catch(x => {
                alert(this.translate('errors.loginFailed'));
                console.log('Oturum aç cevabı: ', x);
            })
            .then(() => {
                this.processingMessage = null;
                this.loading = false;
            });
        },
        imzalayiciOnLoading(e){
            this.imzalayiciLoading = e;
        },
        imzalayiciOnError() {
            this.loading = false;
            this.imzalayiciLoading = false;
        },
        imzalayiciModeChange(mode){
            console.log('mode change:', mode);
            this.imzalayiciMode = mode;
        },
        sign(){
            this.errorMessage = '';
            this.processingMessage = this.translate('processingMessages.loginAgreementPreparing');
            this.signingItems[0].GetUrl = 'token/ESignatureLoginAgreement?accountCode=' + this.accountCode
            this.chooseAccount = false;
            this.$forceUpdate();
            if(this.signingItems) {
                if(this.$refs.imzalayici.sign()){
                    this.processingMessage = this.translate('processingMessages.loginAgreementSigning');
                    this.loading = true;
                }
            }
            
        }
    }
}
</script>